import { render } from "./carCompatibility.vue?vue&type=template&id=87b356e4"
import script from "./carCompatibility.vue?vue&type=script&lang=js"
export * from "./carCompatibility.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__